"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddGuildQuestBodyToJSON = exports.AddGuildQuestBodyFromJSONTyped = exports.AddGuildQuestBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function AddGuildQuestBodyFromJSON(json) {
    return AddGuildQuestBodyFromJSONTyped(json, false);
}
exports.AddGuildQuestBodyFromJSON = AddGuildQuestBodyFromJSON;
function AddGuildQuestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'guild': !(0, runtime_1.exists)(json, 'guild') ? undefined : json['guild'],
        'game': !(0, runtime_1.exists)(json, 'game') ? undefined : json['game'],
        'name': json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'eventType': (0, _1.OWGameEventTypeFromJSON)(json['eventType']),
        'target': json['target'],
        'isActive': !(0, runtime_1.exists)(json, 'isActive') ? undefined : json['isActive'],
        'milestones': !(0, runtime_1.exists)(json, 'milestones') ? undefined : (json['milestones'].map(_1.CreateMilestoneRequestFromJSON)),
        'rewardConfigIds': !(0, runtime_1.exists)(json, 'rewardConfigIds') ? undefined : json['rewardConfigIds'],
        'isGuildQualifier': !(0, runtime_1.exists)(json, 'isGuildQualifier') ? undefined : json['isGuildQualifier'],
        'mode': !(0, runtime_1.exists)(json, 'mode') ? undefined : (0, _1.GuildQuestModeFromJSON)(json['mode']),
        'dailyTarget': !(0, runtime_1.exists)(json, 'dailyTarget') ? undefined : json['dailyTarget'],
    };
}
exports.AddGuildQuestBodyFromJSONTyped = AddGuildQuestBodyFromJSONTyped;
function AddGuildQuestBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'guild': value.guild,
        'game': value.game,
        'name': value.name,
        'description': value.description,
        'eventType': (0, _1.OWGameEventTypeToJSON)(value.eventType),
        'target': value.target,
        'isActive': value.isActive,
        'milestones': value.milestones === undefined ? undefined : (value.milestones.map(_1.CreateMilestoneRequestToJSON)),
        'rewardConfigIds': value.rewardConfigIds,
        'isGuildQualifier': value.isGuildQualifier,
        'mode': (0, _1.GuildQuestModeToJSON)(value.mode),
        'dailyTarget': value.dailyTarget,
    };
}
exports.AddGuildQuestBodyToJSON = AddGuildQuestBodyToJSON;
